import React from 'react';
import { Link } from 'react-router-dom';
import PreviewThemeToggle from './PreviewThemeToggle';
import { v2BrandLogo, whatsappUrl } from '../../pages/SiteRefreshPreview/siteRefreshContent';

const PreviewHeader = ({ links }) => (
  <header className="site-refresh__header">
    <div className="site-refresh__shell site-refresh__header-inner">
      <Link to="/v2" className="site-refresh__brand">
        <img src={v2BrandLogo} alt="Napalm Studio" className="site-refresh__brand-icon" />
        <span className="site-refresh__brand-text">
        </span>
      </Link>

      <nav className="site-refresh__nav" aria-label="Principal">
        {links.map((link) => (
          <a key={link.label} href={link.href} className="site-refresh__nav-link">
            {link.label}
          </a>
        ))}
      </nav>

      <div className="site-refresh__header-actions">
        <PreviewThemeToggle />
        <a
          href={whatsappUrl}
          className="site-refresh__button site-refresh__button--primary site-refresh__header-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          Vamos conversar
          <span className="site-refresh__arrow" aria-hidden="true">
            →
          </span>
        </a>
      </div>
    </div>
  </header>
);

export default PreviewHeader;
